import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    class: "goods-box"
};
const _hoisted_2 = {
    key: 0,
    style: {
        "width": "70%"
    }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_input_number = _resolveComponent("el-input-number");
    const _component_el_form_item = _resolveComponent("el-form-item");
    const _component_el_button_group = _resolveComponent("el-button-group");
    const _component_scTable = _resolveComponent("scTable");
    const _component_Goods = _resolveComponent("Goods");
    const _directive_loading = _resolveDirective("loading");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                class: "add-item",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.choose && $options.choose(...args))
            }, [
                _createVNode(_component_el_button, {
                    type: "primary"
                }, {
                    default: _withCtx(()=>[
                            ..._cache[2] || (_cache[2] = [
                                _createTextVNode("添加权益内容", -1)
                            ])
                        ]),
                    _: 1
                })
            ]),
            $data.value && $data.value.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives((_openBlock(), _createBlock(_component_scTable, {
                    ref: "table",
                    data: $data.value,
                    width: "400px",
                    stripe: "",
                    border: "",
                    showFlex: false,
                    hideDo: "",
                    hidePagination: "",
                    "row-key": "id"
                }, {
                    default: _withCtx(()=>[
                            _createVNode(_component_el_table_column, {
                                label: "商品ID",
                                prop: "id",
                                width: "120",
                                align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "归属部门",
                                prop: "supplier.title",
                                width: "120",
                                align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "商品名称",
                                prop: "title",
                                align: "center",
                                "min-width": "150"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "商品售价",
                                prop: "title",
                                align: "center",
                                "min-width": "150"
                            }, {
                                default: _withCtx(({ row })=>[
                                        _createTextVNode(_toDisplayString(row.price == 0 ? "--" : `${"￥" + row.price}`), 1)
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "排序",
                                prop: "order",
                                width: "120",
                                align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "是否分成",
                                prop: "title",
                                align: "center",
                                "min-width": "150"
                            }, {
                                default: _withCtx(({ row })=>[
                                        _createTextVNode(_toDisplayString(row.commission_type == 0 ? "不分成" : "分成"), 1)
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "赠送数量",
                                prop: "num",
                                width: "200",
                                align: "center"
                            }, {
                                default: _withCtx(({ row, $index })=>[
                                        _createVNode(_component_el_form_item, {
                                            "label-width": "0",
                                            prop: `package.${_ctx.index}.num`
                                        }, {
                                            default: _withCtx(()=>[
                                                    _createVNode(_component_el_input_number, {
                                                        style: {
                                                            "width": "100%"
                                                        },
                                                        modelValue: row.num,
                                                        "onUpdate:modelValue": ($event)=>row.num = $event,
                                                        min: 0,
                                                        step: 1,
                                                        placeholder: "数量"
                                                    }, null, 8, [
                                                        "modelValue",
                                                        "onUpdate:modelValue"
                                                    ])
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "prop"
                                        ])
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "更新时间",
                                prop: "created_at",
                                align: "center",
                                "min-width": "150"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "操作",
                                fixed: "right",
                                align: "center",
                                width: "120"
                            }, {
                                default: _withCtx(({ row, $index })=>[
                                        _createVNode(_component_el_button_group, null, {
                                            default: _withCtx(()=>[
                                                    _createVNode(_component_el_button, {
                                                        link: "",
                                                        type: "primary",
                                                        size: "small",
                                                        onClick: ($event)=>$options.deleteData(row, $index)
                                                    }, {
                                                        default: _withCtx(()=>[
                                                                ..._cache[3] || (_cache[3] = [
                                                                    _createTextVNode("取消选择", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    }, 8, [
                                                        "onClick"
                                                    ])
                                                ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "data"
                ])), [
                    [
                        _directive_loading,
                        _ctx.isLoading
                    ]
                ])
            ])) : _createCommentVNode("", true)
        ]),
        $data.dialog.save ? (_openBlock(), _createBlock(_component_Goods, {
            key: 0,
            ref: "GoodsDialog",
            onSuccess: $options.handleSuccess,
            onClosed: _cache[1] || (_cache[1] = ($event)=>$data.dialog.save = false)
        }, null, 8, [
            "onSuccess"
        ])) : _createCommentVNode("", true)
    ], 64);
}
